module.exports = __webpack_public_path__ + "static/media/protective_ring.b54f881a.png";